import { useState, useEffect } from 'react';

import { paths } from 'src/routes/paths';

import { useCollectiblesStore } from 'src/stores/benefits/collectibles.store';

export const useBenefitsBottomsheet = () => {
  const { hasActiveCollection } = useCollectiblesStore();
  const [OPTIONS, setOPTIONS] = useState([
    // { title: 'Experiências', imgPath: '/assets/images/benefits/03-experiencias.png', path: paths.experiences.root },
    {
      title: 'Produtos',
      imgPath: '/assets/images/benefits/02-produtos.png',
      path: paths.products.root,
    },
    { title: 'Cupons', imgPath: '/assets/images/benefits/04-cupons.png', path: paths.coupons.root },
    {
      title: 'Sorteios',
      imgPath: '/assets/images/benefits/05-promo.png',
      path: paths.promotions.root,
    },
    {
      title: 'Experiências',
      imgPath: '/assets/images/benefits/06-eventos.png',
      path: paths.events.root,
    },
  ]);

  useEffect(() => {
    setOPTIONS((prev) => {
      const baseOptions = [
        // { title: 'Experiências', imgPath: '/assets/images/benefits/03-experiencias.png', path: paths.experiences.root },
        {
          title: 'Produtos',
          imgPath: '/assets/images/benefits/02-produtos.png',
          path: paths.products.root,
        },
        {
          title: 'Cupons',
          imgPath: '/assets/images/benefits/04-cupons.png',
          path: paths.coupons.root,
        },
        {
          title: 'Sorteios',
          imgPath: '/assets/images/benefits/05-promo.png',
          path: paths.promotions.root,
        },
        {
          title: 'Experiências',
          imgPath: '/assets/images/benefits/06-eventos.png',
          path: paths.events.root,
        },
      ];
      if (hasActiveCollection) {
        baseOptions.splice(1, 0, {
          title: 'Colecionáveis',
          imgPath: '/assets/images/benefits/01-colecionaveis.png',
          path: paths.collectibles.root,
        });
      }
      return baseOptions;
    });
  }, [hasActiveCollection]);

  return {
    OPTIONS,
  };
};
